import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { ReactElement } from "react";
import Samples from "./Samples";
import SearchIcon from "@mui/icons-material/Search";
import { useRef, useState } from "react";
import { getMRPCResults } from "../../../../api/llm";
import { LLMMRPCResponse } from "../../../../types/llm";
import Results from "./Results";
import Disclaimer from "../Disclaimer";
import TaskInfo from "../TaskInfo";
import PredictingOverlay from "../PredictingOverlay";

interface MRPCProps {
  index: number;
  tabValue: number;
}

const MRPC = (props: MRPCProps): ReactElement => {
  const { tabValue, index } = props;
  const [inputSentence1, setInputSentence1] = useState("");
  const [inputSentence2, setInputSentence2] = useState("");
  const [results, setResults] = useState<LLMMRPCResponse | undefined>(
    undefined,
  );
  const [isPredicting, setIsPredicting] = useState(false);
  const isPredictingRef = useRef(false);

  const handleSampleSelected = (sentence1: string, sentence2: string) => {
    setInputSentence1(sentence1);
    setInputSentence2(sentence2);
  };

  const handleInputSampleClick = () => {
    if (isPredictingRef.current) {
      return;
    }

    isPredictingRef.current = true;
    setIsPredicting(true);
    getMRPCResults(inputSentence1, inputSentence2)
      .then((response) => {
        console.log(response);
        setResults(response);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        isPredictingRef.current = false;
        setIsPredicting(false);
      });
  };

  return tabValue === index ? (
    <Container sx={{ marginTop: 5 }} hidden={tabValue !== index}>
      <Disclaimer />
      <TaskInfo
        name="MRPC"
        meaning="Microsoft Research Paraphrase Corpus"
        description="MRPC, the Microsoft Research Paraphrase Corpus task, compares two sentences and predicts whether they are paraphrases, meaning whether they express the same idea with different wording."
      />
      <Grid container spacing={2} columns={10}>
        <Grid item xs={10} md={6}>
          <Paper
            elevation={2}
            sx={{
              padding: 3,
              border: "1px solid",
              borderColor: "divider",
              position: "relative",
              overflow: "hidden",
            }}
          >
            <PredictingOverlay open={isPredicting} />
            <Stack spacing={2.5}>
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Sentence 1"
                placeholder="Write the first sentence"
                id="input-sentence1-text"
                value={inputSentence1}
                onChange={(e) => setInputSentence1(e.target.value)}
              />
              <TextField
                fullWidth
                multiline
                minRows={3}
                maxRows={5}
                label="Sentence 2"
                placeholder="Write the second sentence"
                id="input-sentence2-text"
                value={inputSentence2}
                onChange={(e) => setInputSentence2(e.target.value)}
              />
              <Button
                variant="contained"
                size="large"
                fullWidth
                startIcon={<SearchIcon />}
                disabled={isPredicting}
                onClick={() => handleInputSampleClick()}
              >
                Compare
              </Button>
            </Stack>
          </Paper>
          <Container sx={{ marginTop: 2 }}>
            <Results results={results} />
          </Container>
        </Grid>
        <Grid item xs={10} md={4}>
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Examples
            </Typography>
            <Samples sampleSelectedCallback={handleSampleSelected}></Samples>
          </Stack>
        </Grid>
      </Grid>
    </Container>
  ) : (
    <></>
  );
};

export default MRPC;
